module.exports = __webpack_public_path__ + "static/illustration-2.0c274126.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/illustration-2.png
// module id = 1021
// module chunks = 2